import { render, staticRenderFns } from "./BillingSvg.vue?vue&type=template&id=0cfa62b4"
import script from "./BillingSvg.vue?vue&type=script&lang=js"
export * from "./BillingSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports